
import { useState } from "react";

export const useTabState = () => {
  const [activeTab, setActiveTab] = useState<string>("projects");
  const [activeSubTab, setActiveSubTab] = useState<string>("my-projects");

  return {
    activeTab,
    activeSubTab,
    setActiveTab,
    setActiveSubTab
  };
};
